export const suggestions = [
  'Ford',
  'Chevrolet',
  'Mercedes-Benz',
  'Fiat',
  'Porsche',
  'Volkswagen',
  'BMW',
  'Land Rover',
  'Jaguar',
  'Audi',
  'AC',
  'AMC',
  'AMS',
  'AMX',
  'ASA',
  'Abarth',
  'Acura',
  'Adler',
  'Ahrens-Fox',
  'Aixam',
  'Alfa Romeo',
  'Allard',
  'Allgaier',
  'Alpina',
  'Alpine',
  'Alvis',
  'American LeFrance',
  'American Underslung',
  'Amilcar',
  'Amphicar',
  'Andere',
  'Ansaldo',
  'Ardun',
  'Argo',
  'Ariel',
  'Armstrong Siddeley',
  'Arnolt-Bristol',
  'Arrows',
  'Artega',
  'Ascari',
  'Asia Motors',
  'Aston Martin',
  'Auburn',
  'Austin',
  'Austin-Healey',
  'Auto Union',
  'Autobianchi',
  'Auverland',
  'Avanti',
  'BHRAMA',
  'BRM',
  'BSA',
  'Backdraft',
  'Bandini',
  'Bandini-Maserati',
  'Beck',
  'Beijing',
  'Benjamin',
  'Bentley',
  'Benz',
  'Berkeley',
  'Berliet',
  'Berna',
  'Bitter',
  'Bizzarrini',
  'Blackstone',
  'Bobsy',
  'Borgward',
  'Boursaud',
  'Brabham',
  'Bradley',
  'Bricklin',
  'Brilliance',
  'Bristol',
  'Brooke',
  'Bugatti',
  'Buick',
  'Cadillac',
  'Carver',
  'Casalini',
  'Caterham',
  'Chalmers',
  'Chatenet',
  'Checker',
  'Chenard-Walcker',
  'Chevron',
  'Chrysler',
  'Cisitalia',
  'Citroen',
  'Clenet',
  'Colani',
  'Columbia',
  'Connaught',
  'Cooper',
  'Cord',
  'Crestmobile',
  'Crossle',
  'Crossley',
  'DAF',
  'DKW',
  'DMC',
  'DS Automobiles',
  'Dacia',
  'Daewoo',
  'Daihatsu',
  'Daimler',
  'Daren',
  'Datsun',
  'De Sanctis',
  'De-Tomaso',
  'DeSoto',
  'Delage',
  'Delahaye',
  'Delaunay Belleville',
  'Dellow',
  'Deutsch-Bonnet',
  'Devin',
  'Diamond T',
  'Dino',
  'Diva',
  'Dodge',
  'Donkervoort',
  'Duesenberg',
  'E-M-F',
  'Eagle',
  'Edsel',
  'Elcar',
  'Elva',
  'Ensign',
  'Essex',
  'Excalibur',
  'Facel Vega',
  'Factory Five',
  'Fairthorpe',
  'Ferrari',
  'Ferves',
  'Fiat-Abarth',
  'Fiberfab',
  'Fisker',
  'Frazer Nash',
  'Fuldamobil',
  'GAC Gonow',
  'GAZ',
  'GMC',
  'Gardner',
  'Gazelle',
  'Geely',
  'Gemballa',
  'Georges Irat',
  'Georges Richard',
  'Giannini',
  'Ginetta',
  'Glas',
  'Goggomobil',
  'Goliath',
  'Gordon',
  'Gordon Keeble',
  'Grd',
  'Grecav',
  'Gumpert',
  'HRG',
  'Hamman',
  'Hanomag',
  'Hanomag-Henschel',
  'Healey',
  'Heinkel',
  'Hemi',
  'Hillman',
  'Hispano-Suiza',
  'Holden',
  'Holsman',
  'Honda',
  'Horch',
  'Hotchkiss',
  'Hudson',
  'Humber',
  'Hummer',
  'Hupmobile',
  'Huron',
  'Hustler',
  'Hyundai',
  'IFA',
  'Infiniti',
  'Innocenti',
  'Intermeccanica',
  'International Harvester',
  'Invicta',
  'Iran Khodro',
  'Isdera',
  'Iso',
  'Isotta-Fraschini',
  'Isuzu',
  'Italdesign',
  'Iveco',
  'Jeep',
  'Jensen',
  'Jowett',
  'K-1',
  'KTM',
  'Kahn',
  'Kaiser',
  'Kellison',
  'Kia',
  'King',
  'Kirkham',
  'Kleinschnittger',
  'Koenigsegg',
  'Kougar',
  'La Buire',
  'La Salle',
  'LaFayette',
  'Lada',
  'Lagonda',
  'Lamborghini',
  'Lanchester',
  'Lancia',
  'Landwind',
  'Lea Francis',
  'Leon Bollee',
  'Lexus',
  'Leyland',
  'Licorne',
  'Ligier',
  'Lincoln',
  'Lister',
  'Lola',
  'Lorranie-Dietrich',
  'Lotec',
  'Lotus',
  'Luxgen',
  'MG',
  'MG-Lola',
  'MINI',
  'MVS Venturi',
  'Mack',
  'Mahindra',
  'March',
  'Marcos',
  'Marmon',
  'Maserati',
  'Matford',
  'Mathis',
  'Matra',
  'Matra-Simca',
  'Maxwell',
  'Maybach',
  'Mazda',
  'McDowell',
  'McKinney',
  'McLaren',
  'McRae',
  'Melkus',
  'Mercer',
  'Mercury',
  'Merlyn',
  'Messerschmitt',
  'Meyers Manx',
  'Microcar',
  'Minerva',
  'Mitchell',
  'Mitsubishi',
  'Monteverdi',
  'Moretti',
  'Morgan',
  'Morris',
  'Mors',
  'Moskvich',
  'Mosler',
  'NG',
  'NSU',
  'Napier',
  'Nash',
  'Nash Healey',
  'Nekaf',
  'Nissan',
  'Noble',
  'Nomag',
  'O.S.C.A.',
  'Oakland',
  'Oldsmobile',
  'Opel',
  'Orient',
  'Osella',
  'PGO',
  'Packard',
  'Pagani',
  'Panhard',
  'Panhard & Levassor',
  'Panoz',
  'Panther',
  'Peerless',
  'Pegaso',
  'Peterbilt',
  'Peugeot',
  'Piaggio',
  'Pierce-Arrow',
  'Pininfarina',
  'Plymouth',
  'Pontiac',
  'Praga',
  'Prince',
  'Proton',
  'Puma',
  'REO',
  'Raleigh',
  'Regal',
  'Reliant',
  'Renault',
  'Rene Bonnet',
  'Reynard',
  'Rickenbacker',
  'Riley',
  'Rochet-Schneider',
  'Rolland-Pilain',
  'Rolls-Royce',
  'Ronart',
  'Rondeau',
  'Rosengart',
  'Rover',
  'Rudolph Roadster',
  'Ruf',
  'SPCNS',
  'SSC',
  'Saab',
  'Saleen',
  'Salmson',
  'Samsung',
  'Santana',
  'Santler',
  'Saturn',
  'Sauber',
  'Saurer',
  'Sbarro',
  'Scion',
  'Seat',
  'Shelby',
  'Siata',
  'Sima Violet',
  'Simca',
  'Singer',
  'Singer Motors Limited',
  'Skoda',
  'Slisby',
  'Smart',
  'Spartan',
  'Springer',
  'Spyker',
  'Ssangyong',
  'Standard',
  'Standard Vanguard',
  'Stanguellini',
  'Star',
  'Steyr',
  'Stoewer',
  'Straker Squire',
  'Studebaker',
  'Stutz',
  'Subaru',
  'Sunbeam',
  'Sunbeam-Talbot',
  'Surtees',
  'Suzuki',
  'Sylva',
  'TECHART',
  'TOJ',
  'TVR',
  'Talbot',
  'Talbot-Lago',
  'Tata',
  'Tatra',
  'Tempo',
  'Tesla',
  'Thornycroft',
  'Toyota',
  'Trabant',
  'Triking',
  'Triumph',
  'Tucker',
  'Tyrrel',
  'Unic',
  'Vallee',
  'Van Diemen',
  'Vanclee',
  'Vanden Plas',
  'Vauxhall',
  'Vauxhall Victor',
  'Veb-Barkas',
  'Vector',
  'Venturi',
  'Veritas',
  'Vermorel',
  'Vintage Speedsters',
  'Voisin',
  'Volvo',
  'Wanderer',
  'Wartburg',
  'Weineck',
  'Westfield',
  'White Motor Company',
  'Wiesmann',
  'Williams',
  'Willys-Knight',
  'Willys-Overland',
  'Wolseley',
  'Yenko',
  'Zagato',
  'Zastava',
  'Zaz',
  'Zenvo',
  'Zil',
  'Zimmer',
  'speedART',
]
